import {CreateFornecedorComponent} from '@components/fornecedores/CreateFornecedorComponent.tsx';
import {FornecedorInfoRow} from '@components/fornecedores/FornecedorInformacao.tsx';
import {useAlert} from '@contexts/hooks/useAlert.ts';
import {_fornecedor_endpoints} from '@components/fornecedores/endpoints/_fornecedor_endpoints.ts';
import {IPagination} from '@localization/siteMap/siteMapInterfaces.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {IFornecedoresFilterDto} from '@models/fornecedores/dto.ts';
import {IFornecedor} from '@models/fornecedores/fornecedor.ts';
import {AddOutlined, Publish} from '@mui/icons-material';
import {
    ButtonGroup,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import React, {useEffect, useState} from 'react';
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {ImportFornecedoresComponent} from "@components/fornecedores/pages/ImportFornecedoresComponent.tsx";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";

export interface FornecedoresPageProps extends DefaultPageProps {
    filtros?: IFornecedoresFilterDto;
}

export const FornecedoresPage: React.FC<FornecedoresPageProps> = (props) => {
    const {Get} = useApi();
    const {addPopUp, closePopUp} = useAlert();

    const [filtros] = useState<IFornecedoresFilterDto>(props.filtros ?? {});
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    const [fornecedores, setFornecedores] = useState<IFornecedor[]>([]);

    useEffect(() => {
        if (pagination.page === 0) {
            setPagination({...pagination, page: 1});
            return;
        }
        setPagination(prev => ({...prev, loading: true}));
        Get(_fornecedor_endpoints.GetFornecedores(filtros, pagination)).then(x => {
            if (x.hasData) {
                setFornecedores(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}));
        })

    }, [pagination.page, pagination.ignoreCache == true]);


    return (
        <DefaultContainer hideHeader={props.hideHeader} titulo={'Fornecedores'} component={Paper}
                          pageProps={{pagination, setPagination}} size={'large'}
                          UpperComponent={<Grid container justifyContent={'end'}>
                              <Grid component={ButtonGroup}>
                                  <PermissionableButton label={'Criar fornecedor'}
                                                        showEvenWithoutAccess
                                                        icon={<AddOutlined/>}
                                                        permission={['CriarFornecedor']}
                                                        onClick={() => {
                                                            addPopUp({
                                                                title: 'Criar fornecedor',
                                                                content: <CreateFornecedorComponent onCreate={() => {
                                                                    setPagination({...pagination, page: 0});
                                                                    closePopUp();
                                                                }}/>,
                                                                size: 'lg',
                                                            });
                                                        }}
                                  />
                                  <PermissionableButton label={'Importar fornecedores'}
                                                        icon={<Publish/>}
                                                        showEvenWithoutAccess
                                                        permission={['CriarFornecedor']}
                                                        onClick={() => {
                                                            addPopUp({
                                                                title: 'Importar fornecedores',
                                                                content: <ImportFornecedoresComponent onCreate={() => {
                                                                }}/>
                                                            })
                                                        }}
                                  />
                              </Grid>
                          </Grid>}>


            <TableContainer>
                <Table size={'small'} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell>Cpf/Cnpj</TableCell>
                            <TableCell align={'right'}>Mais</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fornecedores && fornecedores.map((x) => (
                            <FornecedorInfoRow value={x}/>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </DefaultContainer>
    );
};